module.exports = __webpack_public_path__ + "static/img/logo-fc3d.7207a6f6.png";